module.exports = __webpack_public_path__ + "93acb1fcf7538b3a614292668257097d.png";